import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function LegalNotice() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'Mentions Légales - Agent IA Pro | Informations Légales';

    const setMeta = (name: string, content: string, attr = 'name') => {
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (el) { el.setAttribute('content', content); }
      else {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        el.setAttribute('content', content);
        document.head.appendChild(el);
      }
    };

    setMeta('robots', 'noindex, nofollow');
    setMeta('description', 'Mentions légales d\'Agent IA Pro. Informations sur l\'éditeur du site, l\'hébergement, la propriété intellectuelle et les données personnelles.');

    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) { canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/legal-notice`); }
    else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/legal-notice`);
      document.head.appendChild(canonical);
    }

    const existingScripts = document.querySelectorAll('script[type="application/ld+json"]');
    existingScripts.forEach(s => s.remove());

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Mentions Légales - Agent IA Pro",
      "description": "Mentions légales d'Agent IA Pro. Informations sur l'éditeur, l'hébergement et la propriété intellectuelle.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/legal-notice`,
      "publisher": {
        "@type": "Organization",
        "name": "Agent IA Pro",
        "url": import.meta.env.VITE_SITE_URL || 'https://example.com'
      }
    });
    document.head.appendChild(script);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Mentions Légales
          </h1>
          
          <p className="text-gray-600 mb-12">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>

          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                1. Informations légales
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique, il est précisé aux utilisateurs du site AgentHub l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                2. Éditeur du site
              </h2>
              <div className="bg-gray-50 p-6 rounded-lg space-y-3">
                <p className="text-gray-700">
                  <strong>Raison sociale :</strong> AgentHub SAS
                </p>
                <p className="text-gray-700">
                  <strong>Forme juridique :</strong> Société par Actions Simplifiée
                </p>
                <p className="text-gray-700">
                  <strong>Capital social :</strong> 100 000 €
                </p>
                <p className="text-gray-700">
                  <strong>Siège social :</strong> 123 Avenue des Champs-Élysées, 75008 Paris, France
                </p>
                <p className="text-gray-700">
                  <strong>SIRET :</strong> 123 456 789 00012
                </p>
                <p className="text-gray-700">
                  <strong>RCS :</strong> Paris B 123 456 789
                </p>
                <p className="text-gray-700">
                  <strong>Numéro de TVA intracommunautaire :</strong> FR 12 123456789
                </p>
                <p className="text-gray-700">
                  <strong>Téléphone :</strong> +33 1 23 45 67 89
                </p>
                <p className="text-gray-700">
                  <strong>Email :</strong> <a href="mailto:contact@agenthub.fr" className="text-teal-600 hover:text-teal-700">contact@agenthub.fr</a>
                </p>
                <p className="text-gray-700">
                  <strong>Directeur de la publication :</strong> Jean Dupont
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                3. Hébergement
              </h2>
              <div className="bg-gray-50 p-6 rounded-lg space-y-3">
                <p className="text-gray-700">
                  <strong>Hébergeur :</strong> OVH SAS
                </p>
                <p className="text-gray-700">
                  <strong>Siège social :</strong> 2 rue Kellermann, 59100 Roubaix, France
                </p>
                <p className="text-gray-700">
                  <strong>Téléphone :</strong> 1007
                </p>
                <p className="text-gray-700">
                  <strong>Site web :</strong> <a href="https://www.ovh.com" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700">www.ovh.com</a>
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                4. Propriété intellectuelle
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Les marques, logos, signes et tout autre contenu du site font l'objet d'une protection par le Code de la propriété intellectuelle et plus particulièrement par le droit d'auteur.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                5. Responsabilité
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement remis à jour, mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Si vous constatez une lacune, erreur ou ce qui paraît être un dysfonctionnement, merci de bien vouloir le signaler par email à <a href="mailto:contact@agenthub.fr" className="text-teal-600 hover:text-teal-700">contact@agenthub.fr</a> en décrivant le problème de la manière la plus précise possible.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Tout contenu téléchargé se fait aux risques et périls de l'utilisateur et sous sa seule responsabilité. En conséquence, AgentHub ne saurait être tenu responsable d'un quelconque dommage subi par l'ordinateur de l'utilisateur ou d'une quelconque perte de données consécutives au téléchargement.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Les liens hypertextes mis en place dans le cadre du présent site internet en direction d'autres ressources présentes sur le réseau Internet ne sauraient engager la responsabilité de AgentHub.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                6. Données personnelles
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Pour exercer ces droits, vous pouvez nous contacter :
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mb-4">
                <li>Par email : <a href="mailto:privacy@agenthub.fr" className="text-teal-600 hover:text-teal-700">privacy@agenthub.fr</a></li>
                <li>Par courrier : AgentHub SAS - Service Protection des Données, 123 Avenue des Champs-Élysées, 75008 Paris, France</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                Pour plus d'informations sur la gestion de vos données personnelles, consultez notre <a href="/privacy-policy" className="text-teal-600 hover:text-teal-700 font-medium">Politique de Confidentialité</a>.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                7. Cookies
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Le site AgentHub utilise des cookies pour améliorer l'expérience utilisateur et réaliser des statistiques de visites. Un cookie est un petit fichier texte déposé sur votre ordinateur lors de la visite d'un site.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Les cookies utilisés sur ce site sont les suivants :
              </p>
              <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mb-4">
                <li><strong>Cookies techniques :</strong> Nécessaires au fonctionnement du site</li>
                <li><strong>Cookies analytiques :</strong> Pour mesurer l'audience et améliorer le site</li>
                <li><strong>Cookies de préférence :</strong> Pour mémoriser vos choix et personnaliser votre expérience</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                Vous pouvez à tout moment désactiver les cookies depuis les paramètres de votre navigateur. Cependant, certaines fonctionnalités du site pourraient ne plus être disponibles.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                8. Droit applicable et juridiction compétente
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux français conformément aux règles de compétence en vigueur.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Tout litige en relation avec l'utilisation du site AgentHub est soumis au droit français. Il est fait attribution exclusive de juridiction aux tribunaux compétents de Paris.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                9. Crédits
              </h2>
              <div className="space-y-3">
                <p className="text-gray-700 leading-relaxed">
                  <strong>Conception et développement :</strong> AgentHub SAS
                </p>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Design graphique :</strong> AgentHub Design Team
                </p>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Icônes :</strong> Remix Icon
                </p>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Images :</strong> Stable Diffusion AI
                </p>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Plateforme :</strong> <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700">Powered by Readdy</a>
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                10. Médiation
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Conformément à l'article L.612-1 du Code de la consommation, nous proposons un dispositif de médiation de la consommation. L'entité de médiation retenue est :
              </p>
              <div className="bg-gray-50 p-6 rounded-lg space-y-3">
                <p className="text-gray-700">
                  <strong>Médiateur de la consommation :</strong> CNPM - Médiation de la consommation
                </p>
                <p className="text-gray-700">
                  <strong>Adresse :</strong> 27 avenue de la Libération, 42400 Saint-Chamond, France
                </p>
                <p className="text-gray-700">
                  <strong>Site web :</strong> <a href="https://www.cnpm-mediation-consommation.eu" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700">www.cnpm-mediation-consommation.eu</a>
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                11. Contact
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Pour toute question concernant ces mentions légales, vous pouvez nous contacter :
              </p>
              <div className="bg-gray-50 p-6 rounded-lg space-y-3">
                <p className="text-gray-700">
                  <strong>Email :</strong> <a href="mailto:contact@agenthub.fr" className="text-teal-600 hover:text-teal-700">contact@agenthub.fr</a>
                </p>
                <p className="text-gray-700">
                  <strong>Téléphone :</strong> +33 1 23 45 67 89
                </p>
                <p className="text-gray-700">
                  <strong>Adresse :</strong> 123 Avenue des Champs-Élysées, 75008 Paris, France
                </p>
                <p className="text-gray-700">
                  <strong>Horaires :</strong> Du lundi au vendredi, de 9h à 18h
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
